<template>
  <div class="sys-container">
    <!-- 查询栏 -->
    <div class="query-nav">
      <el-form ref="queryFormRef" :model="queryForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="5">
            <el-form-item prop="name" label="系统名称">
              <el-input v-model.trim="queryForm.name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="managerUserId" label="子系统超级管理员" label-width="130px">
              <el-select v-model="queryForm.managerUserId" placeholder="请选择">
                <el-option
                  v-for="item in managerUserList"
                  :key="item.userId"
                  :label="item.userName"
                  :value="item.userId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-button type="primary" style="margin-right: 6px;" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-col>
          <el-col :span="4" :offset="4">
            <el-button type="primary" style="float: right;" @click="handleAddNewSys">新增子系统</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 表格区域 -->
    <div class="table">
      <el-table :data="sysList" v-loading="tableLoading" stripe border>
        <el-table-column type="index" label="序号" width="60" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="name" label="子系统名称" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="code" label="子系统唯一编码" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="version" label="版本号" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="address" label="URL地址" align="center" width="300" :resizable="false">
          <template slot-scope="{ row }">
            <span style="color: #409dff;">{{ row.address }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="logo" label="LOGO" align="center" :resizable="false">
          <template slot-scope="{ row }">
            <img :src="row.logo" class="logo" style="width: 80px;height: 80px" />
          </template>
        </el-table-column>
        <el-table-column
          prop="users"
          label="子系统超级管理员"
          align="center"
          :resizable="false"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <span
              v-for="(item,index) in row.managerUserNames"
              :key="item.index"
              :style="{color: item.status == 1 ? '#F56C6C' : ''}"
            >{{item.name}}{{item.status == 1 ? '（冻结）': ''}}{{ index == row.managerUserNames.length - 1 ? '' : ',' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" :resizable="false">
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.status === 0 ? true : false"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="changeSysStatus($event, row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" :resizable="false">
          <template slot-scope="{ row }">
            <el-tooltip class="item" effect="dark" content="修改" placement="top">
              <i
                v-show="!row.status"
                class="iconfont iconcaozuo-1xiugai_1"
                :style="{'marginRight': row.code !== 'roses-platform' ? '16px' : '0'}"
                @click="handleEditSys(row)"
              ></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="分配子系统超级管理员" placement="top">
              <i
                v-show="row.code !== 'roses-platform' && !row.status"
                class="iconfont iconcaozuo-4fenpeiguanliyuanjiaosequanxian_1"
                @click="handleSelectUser(row)"
              ></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页区域 -->
    <div class="page">
      <el-pagination
        :total="total"
        :current-page="queryForm.pageNo"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 30, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>

    <!-- 分配子系统管理员对话框 -->
    <el-dialog
      title="分配子系统超级管理员"
      :visible.sync="userSelectDialogVisible"
      width="700px"
      @close="onCancel"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        label-position="left"
        label-width="180px"
        ref="userSelectFormRef"
        :model="userSelectForm"
      >
        <el-form-item label="子系统名称" prop="appName">
          <el-input v-model="userSelectForm.appName" disabled></el-input>
        </el-form-item>
        <el-form-item
          label="请分配子系统超级管理员"
          prop="managerUserIdList"
          :rules="{ required: true, message: '请选择子系统超级管理员', trigger: 'change' }"
        >
          <el-select
            v-model="userSelectForm.managerUserIdList"
            multiple
            placeholder="请选择"
            style="width: 100%;"
            @change="userSelectChange"
          >
            <el-option
              v-for="item in managerUserList"
              :key="item.userId"
              :label="item.userName"
              :value="item.userId"
              :disabled="item.status === 1"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="userBtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <!-- 新增/编辑子系统对话框 -->
    <el-dialog
      :title="sysDialogTitle"
      :visible.sync="sysDialogVisible"
      width="700px"
      @close="cancelSubmit"
    >
      <el-form
        ref="sysInfoFormRef"
        :model="sysInfoForm"
        :rules="sysInfoFormRules"
        label-width="auto"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="子系统名称" prop="name">
              <el-input
                v-model="sysInfoForm.name"
                placeholder="请输入"
                :disabled="!!sysInfoForm.appId"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="子系统唯一编码" prop="code">
              <el-input v-model="sysInfoForm.code" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="子系统URL地址" prop="address">
              <el-input v-model="sysInfoForm.address" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="LOGO图片上传" prop="logo">
              <upload-img :defaultList="defaultList" @get-file-data="getFileData"></upload-img>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSubmit">取消</el-button>
        <el-button type="primary" :loading="sysBtnLoading" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import UploadImg from 'components/UploadImg.vue';
import sysApi from 'api/home/system-mangement.js';

export default {
  components: {
    UploadImg
  },
  data() {
    const validateCode = (rule, value, callback) => {
      const codeReg = /^[A-Za-z0-9_-]+$/;
      if (value.length === 0) {
        callback(new Error('请输入子系统唯一编码'));
      } else if (!codeReg.test(value)) {
        callback(new Error('仅支持字母、数字、短横线和下划线'));
      } else if (value.length > 50) {
        callback(new Error('唯一编码长度仅限50以下'));
      } else {
        callback();
      }
    };
    return {
      total: 0,
      defaultList: [],
      queryForm: {
        name: '',
        managerUserId: '',
        pageSize: 10,
        pageNo: 1
      },
      managerUserList: [],
      tableLoading: true,
      sysList: [],
      userBtnLoading: false,
      userSelectDialogVisible: false,
      userSelectForm: {
        appName: '',
        appId: '',
        managerUserIdList: []
      },
      sysDialogTitle: '新增子系统',
      sysDialogVisible: false,
      sysBtnLoading: false,
      sysInfoForm: {
        appId: '',
        name: '',
        code: '',
        address: '',
        logo: ''
      },
      sysInfoFormRules: {
        name: [{ required: true, message: '请输入子系统名称', trigger: 'blur' }],
        code: [{ required: true, validator: validateCode, trigger: 'blur' }],
        address: [{ required: true, message: '请输入子系统url地址', trigger: 'blur' }],
        logo: [{ required: true, message: '请上传子系统logo' }]
      }
    };
  },
  created() {
    this.getSysListData();
    this.getManagerUserListData();
  },
  methods: {
    // 获取子系统列表
    getSysListData() {
      this.tableLoading = true;
      sysApi
        .getSysList(this.queryForm)
        .then(res => {
          if (res.data.code === 200) {
            this.total = res.data.data.totalRows;
            this.sysList = res.data.data.rows;
            this.tableLoading = false;
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;
        });
    },
    // 获取管理员下拉列表
    getManagerUserListData() {
      sysApi.getSysUserList().then(res => {
        if (res.data.code === 200) {
          this.managerUserList = res.data.data;
        }
        // else {
        //   this.$message.error(res.data.message);
        // }
      });
    },

    // 修改子系统状态 newStatus 冻结 1  解冻 0
    changeSysStatus(newStatus, row) {
      sysApi
        .postSysStatus({
          appId: row.appId,
          status: newStatus ? 0 : 1
        })
        .then(res => {
          if (res.data.code === 200) {
            this.getSysListData();
            this.$message({
              message: newStatus ? '已成功解冻当前子系统' : '已成功冻结当前子系统',
              type: 'success'
            });
          }
        });
    },
    // 搜索
    handleSearch() {
      this.queryForm.pageNo = 1;
      this.getSysListData();
    },
    // 重置
    handleReset() {
      this.$refs.queryFormRef.resetFields();
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = 10;
      this.getSysListData();
    },
    // 分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNo = 1;
      this.getSysListData();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNo = val;
      this.getSysListData();
    },
    // 点击分配子系统超管
    handleSelectUser(row) {
      // console.log(row);
      this.userSelectForm.appId = row.appId;
      this.userSelectForm.appName = row.name;
      this.userSelectForm.managerUserIdList = [...row.managerUserIdList];
      this.userSelectDialogVisible = true;
    },
    // 子系统管理员选择
    userSelectChange(value) {
      this.userSelectForm.managerUserIdList = value;
    },
    // 取消分配子系统超管
    onCancel() {
      this.userSelectDialogVisible = false;
      this.$refs.userSelectFormRef.resetFields();
    },
    // 确认分配子系统超管
    onSubmit() {
      this.userBtnLoading = true;
      this.$refs.userSelectFormRef.validate(valid => {
        if (!valid) {
          this.userBtnLoading = false;
          return;
        }
        sysApi.postSysAdmin(this.userSelectForm).then(res => {
          console.log(res);
          if (res.data.code === 200) {
            this.userBtnLoading = false;
            this.userSelectDialogVisible = false;
            this.$message({
              message: '分配子系统超级管理员成功',
              type: 'success'
            });
            this.getSysListData();
          } else {
            this.$message.error(res.data.message);
          }
        });
      });
    },
    // 点击新增子系统
    handleAddNewSys() {
      this.sysDialogTitle = '新增子系统';
      this.sysDialogVisible = true;
    },
    // 点击编辑子系统
    handleEditSys(row) {
      this.sysDialogTitle = '编辑子系统';
      this.sysDialogVisible = true;
      this.$nextTick(() => {
        this.sysInfoForm.appId = row.appId;
        this.sysInfoForm.name = row.name;
        this.sysInfoForm.code = row.code;
        this.sysInfoForm.address = row.address;
        this.sysInfoForm.logo = row.logo;
        const fileInfo = {};
        fileInfo.name = row.fileInfoModel.fileOriginName;
        fileInfo.url = row.fileInfoModel.fileUrl;
        this.defaultList.push(fileInfo);
      });
    },
    // 新增子系统
    posyNewSys() {
      sysApi.postNewSys(this.sysInfoForm).then(res => {
        if (res.data.code === 200) {
          this.sysBtnLoading = false;
          this.$message({
            message: '新增子系统成功',
            type: 'success'
          });
          this.cancelSubmit();
          this.handleReset();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 编辑子系统
    postEditSys() {
      sysApi.postEditSys(this.sysInfoForm).then(res => {
        if (res.data.code === 200) {
          this.sysBtnLoading = false;
          this.$message({
            message: '修改子系统成功',
            type: 'success'
          });
          this.cancelSubmit();
          this.getSysListData();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 图片上传获取id
    getFileData(data) {
      this.sysInfoForm.logo = data[0];
    },
    // 取消新增/编辑子系统
    cancelSubmit() {
      this.sysInfoForm.appId = '';
      this.defaultList = [];
      this.$refs.sysInfoFormRef.resetFields();
      this.sysDialogVisible = false;
    },
    // 确认新增/编辑子系统
    handleSubmit() {
      this.sysBtnLoading = true;
      this.$refs.sysInfoFormRef.validate(valid => {
        if (!valid) {
          this.sysBtnLoading = false;
          return;
        }
        // 无id为新增， 有id为编辑
        if (this.sysInfoForm.appId === '') {
          this.posyNewSys();
        } else {
          this.postEditSys();
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.sys-container {
  padding: 16px;

  .query-nav {
    height: 40px;
  }

  .page {
    margin: 16px 0;
    float: right;
  }
}

.iconfont {
  font-size: 28px;
  color: #409dff;
  cursor: pointer;
}
</style>
